export default __webpack_public_path__ + "static/media/motogpracer.7e283efa.png";